<script setup lang="ts">
import InstitutionBadge from '@/components/shared/InstitutionBadge.vue';

interface Props {
  title?: string;
  image?: string;
}

defineProps<Props>();
</script>

<template>
  <div class="flex items-center">
    <InstitutionBadge
      v-if="image"
      :icon="['fas', 'building']"
      :imageSource="image"
      class="mr-3"
    />

    <span class="sr-only" :aria-label="$t('global.institution')" />
    <span :aria-label="title" class="h700">{{ title }}</span>
  </div>
</template>
